/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonPage } from '@ionic/react';
import React from 'react';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconClose } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { Version } from '../components/Version';
export const VersionPage: React.FC<{
	onDismiss: () => {};
}> = ({ onDismiss }) => {
	return (
		<IonPage>
			<Header title="Version" left={<IconButton icon={<IconClose />} onClick={() => onDismiss()} />} />
			<QuirkIonContent flush>
				<Version />
			</QuirkIonContent>
		</IonPage>
	);
};
